import { replaceBackEndUrl, convertTitleToReadable } from '../api_tools'

export default class Artist {
    fromRestData(restData) {
        this.id = restData.id;
        this.slug = restData.slug;
        this.artistlinks = [];
        if(restData.acf){
            this.acf = restData.acf;
        }else{
            this.acf = null;
        }

        // this.links = {
        //     "fi": import.meta.env.ARTISTS_PAGE_URL_FI+"/"+restData.slug,
        //     "en": import.meta.env.ARTISTS_PAGE_URL_EN+"/"+restData.slug
        // };

        if(restData.acf && restData.acf.title && restData.acf.title.length > 0){
            this.h1 = restData.acf.title;
        }else{
            this.h1 = restData.title.rendered;
        }

        this.title = convertTitleToReadable(restData.title.rendered);
        
        this.texts = {
            "fi": replaceBackEndUrl(restData.acf.descriptionFi),
            "en": replaceBackEndUrl(restData.acf.descriptionEn)
        }
        
        if(this.acf.bannerImage){
            if(this.acf.bannerImage.image){
                this.fullPictureUrl = this.acf.bannerImage.image.url;
            }
            if(this.acf.bannerImage.mobileImage){
                this.mobilePictureUrl = this.acf.bannerImage.mobileImage.url;
            }
        }

        if(restData.acf.bannerImage.image){
            this.mediaIdFull = restData.acf.bannerImage.image;
            this.mediaIdMobile = restData.acf.bannerImage.mobileImage;
            this.bgposition = "center center";

            if(restData.acf.bannerImage.imagePosition && restData.acf.bannerImage.imagePosition.length > 0){            
                let bgposition_split = restData.acf.bannerImage.imagePosition.split("_");
                this.bgposition = bgposition_split[0] + " " + bgposition_split[1];
            }
        }

        if(restData.acf && restData.acf.artistLinks){
            let links = restData.acf.artistLinks;
            if(links.website && links.website.length > 0){
                this.artistlinks.push({name: "Website", url: links.website});
            }
            if(links.facebookUrl && links.facebookUrl.length > 0){
                this.artistlinks.push({name: "Facebook", url: links.facebookUrl});
            }
            if(links.twitterUrl && links.twitterUrl.length > 0){
                this.artistlinks.push({name: "Twitter", url: links.twitterUrl});
            }
            if(links.youtubeUrl && links.youtubeUrl.length > 0){
                this.artistlinks.push({name: "Youtube", url: links.youtubeUrl});
            }
            if(links.spotifyUrl && links.spotifyUrl.length > 0){
                this.artistlinks.push({name: "Spotify", url: links.spotifyUrl});
            }
            if(links.instagramUrl && links.instagramUrl.length > 0){
                this.artistlinks.push({name: "Instagram", url: links.instagramUrl});
            }
            this.youtubeEmbed = links.youtubeEmbedId;
        }

        this.shows = restData.acf.shows;

        //add Y-m-d date to show info (pwa frontend uses dates in that format)
        for(let i = 0; i < this.shows.length; i++){
            let date = this.shows[i].date;

            let dateExpl = date.split("/");
            let ymd = dateExpl[2] + "-" + dateExpl[1] + "-" + dateExpl[0];

            this.shows[i].dateYmd = ymd;
        }
    }

    setFullPictureFromRestData(mediaData){
        this.pictureUrl = mediaData.source_url;
        this.pictureAlt = mediaData.alt_text;
    }
    setMobilePictureFromRestData(mediaData){
        this.mobilePictureUrl = mediaData.source_url;
    }
}